import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import * as React from 'react';

export default function ModalButtons({ saveLabel = 'submit request', submitButtonSeverity = undefined, onCancel, onSave, isLoading, isFormValid }: {
  onCancel: () => void,
  onSave: () => void,
  isLoading: boolean,
  isFormValid: boolean,
  saveLabel?: string,
  submitButtonSeverity?: "secondary" | "success" | "info" | "warning" | "danger" | "help" | "contrast" | undefined;
}) {
  return (
    <div className="flex items-center justify-end gap-2">
      <Button severity="secondary" rounded onClick={onCancel}>
        <span className="flex items-center gap-1.5">
          <span>cancel</span>
          <Tag value="ESC" />
        </span>
      </Button>
      <Button severity={submitButtonSeverity} iconPos="left" rounded onClick={onSave} loading={isLoading} disabled={!isFormValid}>{saveLabel}</Button>
    </div>
  );
}